import { hookstate } from '@hookstate/core'

const globalSurveyTemplateStore = hookstate({
});

export default globalSurveyTemplateStore;